module.exports = __webpack_public_path__ + "static/media/whomping-willow.0bc0ff26.jpg";